module.exports = __webpack_public_path__ + "assets/phone.4ab5e783.svg";